import postService from '../services/posts';
import { notify } from './notificationReducer';
import getErrorMsg from '../utils/getErrorMsg';
import type { AppDispatch } from '../store';

/**
 * Build the reaction thunk for a post-holding slice.
 *
 * A user may hold several reactions on one item and remove any of them, and
 * nothing locks — so the call is an idempotent add (PUT) or remove (DELETE)
 * rather than a toggle, and the caller passes which one it wants based on what
 * it is currently rendering.
 *
 * The response carries the authoritative reaction state, which replaces the
 * optimistic guess. Each slice listens on its own action type so a dispatch
 * never leaks across slices.
 */
export const createReactionThunk = (actionType: string) => {
  return (id: string, reactionKey: string, held: boolean) => {
    return async (dispatch: AppDispatch) => {
      try {
        const data = await postService.setReaction(id, reactionKey, !held);
        dispatch({
          type: actionType,
          payload: {
            id,
            data: {
              reactions: data.reactions,
              reactionEntries: data.reactionEntries,
              trueReactionCount: data.trueReactionCount,
              falseReactionCount: data.falseReactionCount,
            },
          },
        });
      } catch (err) {
        dispatch(notify(getErrorMsg(err), 'error'));
      }
    };
  };
};
